{% block swag_cms_extensions_form_element_select %}
    <mt-select
        :label="field.translated ? field.translated.label : field.label"
        :required="field.required"
        :options="[]"
        :disabled
    >
        <option
            value=""
            :disabled="field.required"
            selected
        >
            {{ field.translated ? field.translated.placeholder : field.placeholder }}
        </option>
    </mt-select>
{% endblock %}
